import { render, staticRenderFns } from "./ChoicePaymentCancel.vue?vue&type=template&id=222776c2&scoped=true&"
import script from "./ChoicePaymentCancel.vue?vue&type=script&lang=js&"
export * from "./ChoicePaymentCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222776c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222776c2')) {
      api.createRecord('222776c2', component.options)
    } else {
      api.reload('222776c2', component.options)
    }
    module.hot.accept("./ChoicePaymentCancel.vue?vue&type=template&id=222776c2&scoped=true&", function () {
      api.rerender('222776c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/services/payments/ChoicePaymentCancel.vue"
export default component.exports